// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDownOutlinedSvg from "@fishx/icons-svg/es/asn/PDownOutlined";
import FishxIcon from '../components/FishxIcon';

var PDownOutlined = function PDownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDownOutlinedSvg
  }));
};

PDownOutlined.displayName = 'PDownOutlined';
export default React.forwardRef(PDownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDownOutlined.js
// module id = 3346
// module chunks = 0